// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2iW54","amount":"Amount_amount__1L_iF","tip":"Amount_tip__184we","tipHeader":"Amount_tipHeader__1vK3E","tipsWrap":"Amount_tipsWrap__2f5Nj"};